module.exports = __webpack_public_path__ + "static/media/Cameron Diaz Headshot New_1602612099771.abcd62b9.png";